import { useGetSubnetListQuery } from "@/react/features/globalization/globalizationApi";
import TableComponent from "@/react/components/table/TableComponent";
import React from "react";
import { subnetColumnDefinition } from "@/react/features/globalization/columnDefinition";
import { subnet } from "@/react/features/globalization/schema";
import { OpenInTapFAB } from "@/react/features/globalization/OpenInTapFAB";
import { useTable } from "@/react/components/table/useTable";
import schema from "@/react/features/vcc/agent-groups/schema";
import styled from "styled-components";
import TableWrapper from "@/react/features/styled/TableWrapper";

const columns = Object.freeze(subnetColumnDefinition);

const Title = styled.h4`
  padding: 24px;
  margin-bottom: 0;
`;

export function GlobalizationSubnetPage() {
  const { data: subnetList, refetch, isFetching } = useGetSubnetListQuery();

  const {
    table,
    filters,
    state,
    mutations: { updateRows, resetData },
  } = useTable(subnetList, columns, subnet, "id");

  return (
    <OpenInTapFAB>
      <Title>Subnet List</Title>
      <TableWrapper>
        <TableComponent
          title="Subnet List"
          schema={schema}
          isLoading={isFetching}
          onCancel={resetData}
          onRefresh={refetch}
          table={table}
          filters={filters}
          mutations={{ updateRows }}
          state={state}
          fileActions={false}
        />
      </TableWrapper>
    </OpenInTapFAB>
  );
}
